import {merge} from "lodash";
import partnerMessages from "@i18n_messages_fr"

export default merge({}, partnerMessages);